import { Button } from '@mui/material';
import FormProvider from '@Components/hook-form';

import { AtLocator } from '@Components/shared/locators/AtLocator';

import { CreateDialogFooterLayout } from '@Components/shared/layouts/CreateDialogFooterLayout';
import { CreateDialogLayout } from '@Components/shared/layouts/CreateDialogLayout';

import { CreateFreebetsContent } from './CreateFreebetsContent';
import { useCreateFreebets } from '@Modal/hooks/freebets/useCreateFreebets';
import { useCreateFreebetsForm } from '@Forms/freebets/CreateFreebetsFormContext';

export const CreateFreebetsForm = () => {
  const methods = useCreateFreebetsForm();
  const { handleCreateCancel, submittable, handleSubmitCreateFreebets } = useCreateFreebets();

  return (
    <FormProvider methods={methods}>
      <CreateDialogLayout>
        <CreateFreebetsContent />
        <CreateDialogFooterLayout>
          <AtLocator type="button" name="Cancel">
            <Button variant="outlined" color="inherit" onClick={handleCreateCancel}>
              Cancel
            </Button>
          </AtLocator>
          <AtLocator type="button" name="Submit">
            <Button
              type="submit"
              variant="contained"
              disabled={!submittable}
              onClick={handleSubmitCreateFreebets}
            >
              Confirm
            </Button>
          </AtLocator>
        </CreateDialogFooterLayout>
      </CreateDialogLayout>
    </FormProvider>
  );
};
